/* eslint-disable import/prefer-default-export */
export const getTokens = (state) => state.tokens || [];
